export class AudioplayerPostmessage {
    setup() {
        window.addEventListener("message", (e) => this.handleMessage(e));
    }

    handleMessage(e) {
        const receivedSource = e.data?.audioguideSource ?? null;

        if (receivedSource) {
            window.dispatchEvent(new CustomEvent('audioguide:open', { detail: { guide: receivedSource, expand: true } }));
        }
    };
}

